import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchPaginatedMenuItems } from '@/renderer/services/menuServicePaginated';
import type { MenuItemsFilterParams } from '@/renderer/types/pagination';

export function useMenuItemsPaginated(params: MenuItemsFilterParams) {
  return useQuery({
    queryKey: queryKeys.menu.menuItemsList(params),
    queryFn: async () => {
      const result = await fetchPaginatedMenuItems(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch menu items');
      }
      return result.data;
    },
    // A null/undefined outletId is a valid company-wide view (e.g. a super
    // user viewing "All Outlets"), not "not ready yet" — always enabled.
    placeholderData: keepPreviousData,
  });
}
